import { useCallback, useEffect, useRef } from 'react';
import { useRecoilState } from 'recoil';
import * as atoms from '../atoms';

type Props = {
  restoreOnUnmount?: boolean;
};

const useToggleTreeView = ({ restoreOnUnmount }: Props = {}) => {
  const [treeViewCollapsed, setTreeViewCollapsedState] = useRecoilState(
    atoms.treeViewCollapsed,
  );
  const initialTreeViewCollapsed = useRef(treeViewCollapsed);

  const setTreeViewCollapsed = useCallback(
    (isCollapsed: boolean) => {
      setTreeViewCollapsedState({
        isCollapsed,
        userOverride: isCollapsed,
      });
    },
    [setTreeViewCollapsedState],
  );

  const toggleTreeView = useCallback(() => {
    setTreeViewCollapsedState((current) => {
      const nextIsCollapsed = !current.isCollapsed;
      return {
        isCollapsed: nextIsCollapsed,
        userOverride: nextIsCollapsed,
      };
    });
  }, [setTreeViewCollapsedState]);

  useEffect(() => {
    if (!restoreOnUnmount) return undefined;

    const previousTreeViewCollapsed = initialTreeViewCollapsed.current;

    return () => {
      setTreeViewCollapsedState(previousTreeViewCollapsed);
    };
  }, [restoreOnUnmount, setTreeViewCollapsedState]);

  return {
    treeViewCollapsed,
    setTreeViewCollapsed,
    toggleTreeView,
  };
};

export default useToggleTreeView;
